<template>
  <el-form ref="postForm" :rules="rules" :model="postForm">
    <el-form-item label="类型" prop="food_type">
      <Select key="4" :selected.sync="postForm.food_type" :data="selectList" clearable placeholder="请选择" />
    </el-form-item>
    <el-form-item label="名称" prop="food_name">
      <el-input v-model="postForm.food_name" placeholder="请输入菜品名称" style="width:80%" />
    </el-form-item>
    <el-form-item label="图片">
      <UploadImg
        :photo.sync="postForm.food_picture"
        :name="'food_picture'"
        @updateImg="updatePhoto"
      />
      <div class="upload-notice">请上传200*200像素的图片</div>

    </el-form-item>
    <el-form-item label="食材" prop="food_material">
      <el-input
        v-model="postForm.food_material"
        placeholder="输入食材及数量，如：鸡蛋20g"
        type="textarea"
        :rows="2"
      />
    </el-form-item>
    <el-form-item label="营养师解读">
      <el-input
        v-model="postForm.food_nutrient_content"
        placeholder="输入营养师解读(选填)"
        type="textarea"
        :rows="2"
      />
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        class="fn-right"
        @click="fnHandleSave"
      >保存
      </el-button>
    </el-form-item>

  </el-form>
</template>
<script>

import Select from '@/components/Select'
import UploadImg from '@/components/toolbar/UploadImg.vue'

const defaultForm = {
  food_id: '',
  food_type: '',
  food_name: '',
  food_picture: '',
  food_material: '',
  food_nutrient_content: ''
}
import { validateRequire } from '@/utils/validate'

export default {
  name: 'AddFood',
  components: {
    Select,
    UploadImg
  },
  props: {
    food: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      postForm: Object.assign({}, defaultForm),
      selectList: [],
      rules: {
        food_type: [{ validator: validateRequire, trigger: 'manual', message: '类型' }],
        food_name: [{ validator: validateRequire, trigger: 'manual', message: '名称' }],
        food_picture: [{ validator: validateRequire, trigger: 'manual', message: '图片' }],
        food_material: [{ validator: validateRequire, trigger: 'manual', message: '配料' }]
      }
    }
  },
  created() {
    if (this.food) {
      this.postForm = Object.assign(this.postForm, this.food)
      this.postForm.food_type = parseInt(this.postForm.food_type)
    }
  },
  mounted() {
    this.fnGetSelectList()
  },
  methods: {
    fnGetSelectList: function() {
      this.$http.getDeploy().then(res => {
        this.selectList = res.data.food_type
      })
    },
    fnHandleSave: function() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          this.$http.addFood(this.postForm).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '添加成功'
              })
            }
            this.$emit('successCBK')
          })
        }
      })
    },
    updatePhoto: function(photo, name) {
      this.postForm.food_picture = photo
    }
  }
}
</script>
<style lang="scss" scope>

.combo-group {
  .tuolele-main-search {
    .el-button {
      margin-left:0px!important
    }
    .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 20px !important;
    }
    .el-tabs--top .el-tabs__item.is-top:last-child {
      padding-right: 20px !important;
    }
    .el-form-item__label {
      font-size: 16px;
      color: #333;
    }
    .el-form-item__content {
      margin: 0 20px 0 12px;
    }
  }
}
</style>
